export default "__VITE_ASSET__DVlurFni__"